export function QuickActionIcon({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="26"
        height="64"
        viewBox="0 0 26 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          fill="currentColor"
        />
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          stroke="currentColor"
        />
        <path
          d="M8.5 32H17.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 36.5V27.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0 0C0 3.86599 3.13401 7 7 7H0V0Z" fill="currentColor" />
        <path d="M0 64C0 60.134 3.13401 57 7 57H0V64Z" fill="currentColor" />
      </svg>
    </span>
  );
}
